import { supabase } from '../supabaseClient';

/**
 * Triggers a Zapier Webhook for a specific event
 * @param {string} trainerId - The ID of the trainer
 * @param {string} eventType - 'client_created', 'task_completed', or 'video_submitted'
 * @param {object} payload - The data to send to Zapier
 */
export const triggerZapierEvent = async (trainerId, eventType, payload) => {
  try {
    // 1. Fetch the enabled webhook for this trainer and event
    const { data: integration, error } = await supabase
      .from('trainer_integrations_20250218')
      .select('webhook_url')
      .eq('trainer_id', trainerId)
      .eq('event_type', eventType)
      .eq('is_enabled', true)
      .maybeSingle();

    if (error || !integration?.webhook_url) return;

    // 2. Send the POST request to Zapier
    const response = await fetch(integration.webhook_url, {
      method: 'POST',
      mode: 'no-cors', // Zapier webhooks often don't support CORS but still process the request
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event: eventType,
        timestamp: new Date().toISOString(),
        ...payload
      }),
    });

    console.log(`Zapier event ${eventType} triggered successfully`);
  } catch (err) {
    console.error('Zapier trigger failed:', err);
  }
};